<template>
  <div class="container">
    <!-- 面包屑 -->
    <div class="integralBreadcrumb">
      <div class="integralBreadcrumb-item" @click="routerHandle('basicInfo')">个人中心</div>
      <div class="el-icon-arrow-right jt"></div>
      <div class="integralBreadcrumb-item" @click="routerHandle('equipmentList', 'productionDataManagement')">设备管理</div>
      <div class="el-icon-arrow-right jt"></div>
      <div class="integralBreadcrumb-item">{{equipmentId?'修改':'新增'}}</div>
    </div>
    <!-- 设备信息 -->
    <el-form :inline="true" :model="dataForm" ref="dataForm" :rules="dataRule" label-width="120px" @submit.native.prevent>
      <div class="body-info" v-if="dataForm">
        <h2>设备信息</h2>
        <el-form-item label="设备编号：" prop="equipmentCode">
          <el-input v-model="dataForm.equipmentCode" placeholder="请输入设备编号" maxlength="20" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="设备名称：" prop="equipmentName">
          <el-input v-model="dataForm.equipmentName" placeholder="请输入设备名称" maxlength="50" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="设备状态：" prop="equipmentStatus">
          <el-select v-model="dataForm.equipmentStatus" placeholder="请选择" style="width:210px;" clearable="">
            <el-option value="0" label="正常" key="0"></el-option>
            <el-option value="1" label="维修" key="1"></el-option>
            <el-option value="2" label="闲置" key="2"></el-option>
            <el-option value="3" label="报废" key="3"></el-option>
          </el-select>
          <!-- <span v-if="dataForm.equipmentStatus === '1'">维修</span>
          <span v-else>正常</span> -->
        </el-form-item>
        <el-form-item label="设备类别：" prop="equipmentType">
          <el-input v-model="dataForm.equipmentType" placeholder="请输入设备类别" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="折旧率(%)：" prop="depreciationRate">
          <el-input v-model="dataForm.depreciationRate" placeholder="请输入折旧率" maxlength="20" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="产品型号：" prop="productModel">
          <el-input v-model="dataForm.productModel" placeholder="请输入产品型号" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="设备规格：" prop="equipmentSpecification">
          <el-input v-model="dataForm.equipmentSpecification" placeholder="请输入设备规格" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="价格(元)：" prop="price">
          <el-input v-model="dataForm.price" placeholder="请输入价格" maxlength="20" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="录入时间：" prop="createTime">
          {{dataForm.createTime}}
        </el-form-item>
        <div>&nbsp;</div>
        <el-form-item label="出厂编码：" prop="factoryCode">
          <el-input v-model="dataForm.factoryCode" placeholder="请输入出厂编码" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="出厂时间：" prop="produceDate">
          <el-date-picker v-model="dataForm.produceDate" type="date" placeholder="请选择出厂时间" value-format="yyyy-MM-dd"></el-date-picker>
          <!-- <el-input v-model="dataForm.produceDate" placeholder="请选择出厂时间" clearable style="width:210px;"></el-input> -->
        </el-form-item>
        <el-form-item label="供应商：" prop="supplier">
          <el-input v-model="dataForm.supplier" placeholder="请输入供应商" maxlength="20" clearable style="width:210px;"></el-input>
        </el-form-item>
        <div>&nbsp;</div>
        <el-form-item label="隶属工作中心：" prop="subordinateWorkingArea">
          <el-input v-model="dataForm.subordinateWorkingArea" placeholder="请输入隶属工作中心" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="隶属车间：" prop="subordinateWorkshop">
          <el-input v-model="dataForm.subordinateWorkshop" placeholder="请输入隶属车间" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="所属区域：" prop="subordinateArea">
          <el-input v-model="dataForm.subordinateArea" placeholder="请输入所属区域" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="设备位置：" prop="coordinatePosition">
          <el-input v-model="dataForm.coordinatePosition" placeholder="请输入设备位置" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <div>&nbsp;</div>
        <el-form-item label="责任角色：" prop="responsibilityRole">
          <el-input v-model="dataForm.responsibilityRole" placeholder="请输入责任角色" maxlength="20" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="设备责任人：" prop="equipmentManager">
          <el-input v-model="dataForm.equipmentManager" placeholder="请输入设备责任人" maxlength="20" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="责任人电话：" prop="managerPhone">
          <el-input v-model="dataForm.managerPhone" placeholder="请输入设备责任人电话" maxlength="20" clearable style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="班组：" prop="team">
          <el-input v-model="dataForm.team" placeholder="请输入班组选择" maxlength="100" clearable style="width:210px;"></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 5}" placeholder="请输入备注信息" maxlength="1000" v-model="dataForm.remark" style="width:900px;"></el-input>
        </el-form-item>
      </div>
      <!-- 维修计划信息 -->
      <div class="body-info" v-if="!equipmentId">
        <h2>维修计划信息</h2>
        <el-form-item label="维保修内容：" prop="repairContent">
          <el-input type="textarea" v-model="dataForm.pmEquipmentRepairInfoForm.repairContent" maxlength="2000" :autosize="{ minRows: 5}" placeholder="请输入维保修内容" style="width:900px;"></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="维修日期：" prop="overhaulTime">
          <el-date-picker v-model="dataForm.pmEquipmentRepairInfoForm.overhaulTime" :picker-options="pickerOptions" type="date" placeholder="请输入维修日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="提醒设置：" prop="overhaulRemind">
          <el-select v-model="dataForm.pmEquipmentRepairInfoForm.overhaulRemind" placeholder="请选择">
            <el-option
              v-for="item in overhaulList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维保负责人：" prop="overhaulResponsible">
          <el-input v-model="dataForm.pmEquipmentRepairInfoForm.overhaulResponsible" maxlength="50" placeholder="请输入维保负责人" clearable style="width:210px;"></el-input>
        </el-form-item>
      </div>
      <div class="body-info" v-if="dataForm && dataForm.repairInfoList && equipmentId">
        <h2>设备维修履历</h2>
        <el-table :data="dataForm.repairInfoList" border v-if="dataForm.repairInfoList">
          <el-table-column prop="repairCode" header-align="center" align="center" label="维修计划单单号"></el-table-column>
          <el-table-column prop="nextOverhaulTime" header-align="center" align="center" label="检维修时间" :formatter="formatterDate"></el-table-column>
          <el-table-column prop="overhaulStatus" header-align="center" align="center" label="检维修状态">
            <template slot-scope="scope">
              <span v-if="scope.row.overhaulStatus === 0">执行</span>
              <span v-else-if="scope.row.overhaulStatus === 1">送审</span>
              <span v-else>完成</span>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detailHandle(scope.row)">详情</el-button>
              <!-- <el-button type="text" size="small" @click="repairInfoSS(scope.row)" v-if="scope.row.overhaulStatus === 0">送审</el-button>
              <el-button type="text" size="small" @click="repairInfoDone(scope.row)" v-if="scope.row.overhaulStatus === 1">完成</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="row" style="display:flex;justify-content: center;">
        <!-- 智障的bug -->
        <button style="display:none"></button>
        <!-- /智障的bug -->
        <button :class="'row-opt-but ' + (butLoading?'but-loading':'')" style="margin-right:10px;" @click="routerHandle()">
          <i class="el-icon-loading" v-if="butLoading"></i>
          取消
        </button>
        <button :class="'row-opt-but ' + (butLoading?'but-loading':'')" style="background-color:#1D65A8;color:#fff" @click="submitHandle()">
          <i class="el-icon-loading" v-if="butLoading"></i>
          确定
        </button>
      </div>
    </el-form>
    <Repair ref="repair" v-if="repairVisible"></Repair>
  </div>
</template>
<script>
import {formatDate, isMobile} from '@/utils/validate'
import Repair from './pmequimentrepairinfo-detail'
export default {
  data () {
    var validateRepairContent = (rule, value, callback) => {
      if (!this.dataForm.pmEquipmentRepairInfoForm.repairContent) {
        callback(new Error('维保修内容不能为空'))
      } else {
        callback()
      }
    }
    var validateOverhaulTime = (rule, value, callback) => {
      if (!this.dataForm.pmEquipmentRepairInfoForm.overhaulTime) {
        callback(new Error('维修日期不能为空'))
      } else {
        callback()
      }
    }
    var validateOverhaulResponsible = (rule, value, callback) => {
      if (!this.dataForm.pmEquipmentRepairInfoForm.overhaulResponsible) {
        callback(new Error('维保负责人不能为空'))
      } else {
        callback()
      }
    }
    var validateOverhaulRemind = (rule, value, callback) => {
      if (!this.dataForm.pmEquipmentRepairInfoForm.overhaulRemind) {
        callback(new Error('提醒设置不能为空'))
      } else {
        callback()
      }
    }
    var validateDepreciationRate = (rule, value, callback) => {
      if (!/^[1-9][0-9]{0,1}(\.[0-9]{0,1}[1-9])?$/.test(value)) {
        callback(new Error('折旧率在1～99之间保留两位小数'))
      // }
      // if (value && (parseFloat(value) <= 0)) {
      //   callback(new Error('价格>= 0'))
      } else {
        callback()
      }
    }
    var validatePrice = (rule, value, callback) => {
      // let reg = new RegExp(/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/)
      // /^[0-9]+(.[0-9]{0,3})?$/
      // console.log(value)
        if (!/^[1-9][0-9]*(\.[0-9]{0,1}[1-9])?$/.test(value)) {
          callback(new Error('价格是带有两位小数数字'))
        // }
        // if (value && (parseFloat(value) <= 0)) {
        //   callback(new Error('价格>= 0'))
        } else {
          callback()
        }
    }
    var validateManagerPhone = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      repairVisible:  false,
      dataForm: null,
      butLoading: false,
      dataRule: {
        equipmentCode: [
          { required: true, message: '设备编号不能为空', trigger: 'blur' }
        ],
        equipmentName: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' }
        ],
        equipmentStatus: [
          { required: true, message: '设备状态不能为空', trigger: 'blur' }
        ],
        equipmentType: [
          { required: true, message: '设备类别不能为空', trigger: 'blur' }
        ],
        depreciationRate: [
          { required: true, message: '折旧率不能为空', trigger: 'blur' },
          {validator: validateDepreciationRate, trigger: 'blur', required: true}
        ],
        productModel: [
          { required: true, message: '产品型号不能为空', trigger: 'blur' }
        ],
        equipmentSpecification: [
          { required: true, message: '设备规格不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
          {validator: validatePrice, trigger: 'blur', required: true}
        ],
        subordinateWorkingArea: [
          { required: true, message: '隶属工作中心不能为空', trigger: 'blur' }
        ],
        subordinateWorkshop: [
          { required: true, message: '隶属车间不能为空', trigger: 'blur' }
        ],
        subordinateArea: [
          { required: true, message: '所属区域不能为空', trigger: 'blur' }
        ],
        coordinatePosition: [
          { required: true, message: '设备位置不能为空', trigger: 'blur' }
        ],
        responsibilityRole: [
          { required: true, message: '责任角色不能为空', trigger: 'blur' }
        ],
        equipmentManager: [
          { required: true, message: '设备责任人不能为空', trigger: 'blur' }
        ],
        managerPhone: [
          { required: true, message: '设备责任人电话不能为空', trigger: 'blur' },
          {validator: validateManagerPhone, trigger: 'blur', required: true}
        ],
        team: [
          { required: true, message: '角色不能为空', trigger: 'blur' }
        ],
        repairContent: [
          {validator: validateRepairContent, trigger: 'blur', required: true}
        ],
        overhaulTime: [
          {validator: validateOverhaulTime, trigger: 'blur', required: true}
        ],
        overhaulRemind: [
          {validator: validateOverhaulRemind, trigger: 'blur', required: true}
        ],
        overhaulResponsible: [
          {validator: validateOverhaulResponsible, trigger: 'blur', required: true}
        ]
      },
      overhaulList: [
        {
          label: '提前1天',
          value: "1"
        }, {
          label: '提前3天',
          value: "3"
        }, {
          label: '提前7天',
          value: "7"
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= (Date.now())
        }
      }
    }
  },
  computed: {
    equipmentId () {
      return this.$route.query.id
    }
  },
  watch: {
    equipmentId (val) {
      this.formatFormData()
      if (val) {
        this.getInfo()
      }
    }
  },
  created () {
    if (this.equipmentId) {
      this.getInfo()
    } else {
      this.formatFormData()
    }
  },
  components: {
    Repair
  },
  methods: {
    formatterDate (row, column, value) {
      return formatDate(value)
    },
    handleChange () {
    },
    formatFormData () {
      this.dataForm = {
        "equipmentCode": "",
        "equipmentName": "",
        "equipmentType": '',
        "equipmentStatus": '0',
        "depreciationRate": '',
        "productModel": '',
        "equipmentSpecification": '',
        "price": '',
        "subordinateWorkingArea": '',
        "subordinateWorkshop": '',
        "subordinateArea": '',
        "coordinatePosition": '',
        "responsibilityRole": '',
        "equipmentManager": '',
        "managerPhone": '',
        "team": '',
        "remark": '',
        'factoryCode': '',
        'produceDate': '',
        'supplier': '',
        "pmEquipmentRepairInfoForm":{
          "repairContent": '',
          "overhaulTime": '',
          "overhaulRemind": '1',
          "overhaulResponsible": '',
          "remark": ''
        }
      }
    },
    // 获取数据
    getInfo () {
      this.$http.get(`/front/sys/productequipment/pmequipment/viewPmEquipmentDetail/${this.equipmentId}`)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataForm = data.data || {}
          } else {
            this.dataForm = {}
          }
        })
        .catch(() => {})
    },
    // 提交
    submitHandle () {
      if (this.butLoading) {
        return false
      }
      let _this = this
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.butLoading = true
          this.dataForm.depreciationRate = parseFloat(this.dataForm.depreciationRate) || 0
          this.dataForm.price = parseFloat(this.dataForm.price) || 0
          this.dataForm.equipmentStatus = this.dataForm.equipmentStatus
          this.dataForm.companyId = (this.$store.state.user.defaultCompanyId + '') || ''
          let url = '/front/sys/productequipment/pmequipment/save'
          if (this.equipmentId) {
            url = '/front/sys/productequipment/pmequipment/update'
          }
          this.$http.post(url, this.dataForm)
            .then(({ data }) => {
              if (data && data.code === 0) {
                this.$message({
                  message: (this.equipmentId ? '更新' : '新增') + '设备成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    _this.$router.go(-1)
                    _this.butLoading = false
                  }
                })
              } else {
                this.butLoading = false
              }
            })
            .catch(() => {
              this.butLoading = false
            })
        }
      })
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        this.$router.push({name: name})
      } else {
        this.formatFormData()
        this.$router.go(-1)
      }
    },
    detailHandle (item) {
      this.repairVisible = true
      this.$nextTick(() => {
        this.$refs.repair.dataForm.id = item.id || 0
        this.$refs.repair.preId = 0
        this.$refs.repair.init()
      })
    }
  }
}
</script>
<style scoped>
.body-conent{
  margin: 20px 0;
}
.body-info h2{
  font-size: 20px;
  color: #333333;
  margin-bottom: 40px;
}
.body-info{
  margin: 10px 0;
  width: 100%;
  padding: 40px 70px;
  background-color: #fff;
}
.row{
  display: flex;
  margin: 10px 0;
  line-height: 36px;
  font-size: 16px;
  margin-bottom: 20px;
}
.row-item{
  width: 350px;
  height: 36px;
}
.row-item-label{
  display: inline-block;
  width: 120px;
  text-align: right;
  font-size: 14px;
  color: #333;
}
.row-item-input{
  border: 1px solid #eee;
  padding-left: 10px;
}
.row-item-textarea{
  border: 1px solid #eee;
  padding-left: 10px;
  margin-left:10px;
  width: 90%;
}
/* .row-item-select{
  width: 60%;
} */
.row-opt-but{
  width: 161px;
  height: 50px;
  border: 1px solid #1D65A8;
  background-color: #fff;
  color: #1D65A8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover{
  background-color: #1D65A8;
  color: #fff;
}
</style>


